import Autocomplete from "@mui/material/Autocomplete";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { countries } from "../../utils/constants";
import { RequiredAsterisk } from "../professional/RequiredAsterisk";
import { useMemo } from "react";

export default function CountrySelect({
  id,
  value,
  onChange,
  error,
  helperText,
  required,
  disabled = false,
  multi = false,
  label = "Country",
}) {
  const selectedValue = useMemo(
    () =>
      multi
        ? countries.filter((c) => value?.includes(c.label))
        : countries.find((c) => c.label === value) || null,
    [value, multi],
  );

  return (
    <Autocomplete
      id={id}
      options={countries}
      multiple={multi}
      disabled={disabled}
      value={selectedValue}
      autoHighlight
      getOptionLabel={(option) => option.label}
      isOptionEqualToValue={(opt, val) => opt.label === val.label}
      onChange={(event, newValue) => {
        if (multi) {
          onChange(newValue.map((v) => v.label).join(", ")); // array of strings
        } else {
          onChange(newValue ? newValue.label : ""); // single string
        }
      }}
      renderOption={(props, option) => {
        const { key, ...rest } = props;
        return (
          <Box
            key={key}
            component="li"
            sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
            {...rest}
          >
            <img
              loading="lazy"
              width="20"
              srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
              src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
              alt=""
            />
            {option.label} ({option.code}) +{option.phone}
          </Box>
        );
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          label={
            <span>
              {label} {required && <RequiredAsterisk />}
            </span>
          }
          error={error}
          helperText={helperText}
          slotProps={{
            htmlInput: {
              ...params.inputProps,
              autoComplete: "new-password",
            },
          }}
        />
      )}
    />
  );
}
